
import { useMutation } from '@tanstack/react-query';
import { activityService } from '@/services';
import { ActivityLog } from '@/models/LearnTypes';

export const useActivityMutation = () => {
  const activityMutation = useMutation({
    mutationFn: (activity: Omit<ActivityLog, 'id' | 'timestamp'>) => 
      activityService.logActivity(activity),
    onSuccess: () => {},
  });

  const getActivities = async (userId: string): Promise<ActivityLog[]> => {
    try {
      return await activityService.getUserActivities(userId);
    } catch (error) {
      console.error('Error fetching activities:', error);
      return [];
    }
  };

  return { activityMutation, getActivities };
};
